export default Object.freeze({
  Unset: -1,
  Accepted: 1,
  Rejected: 2,
});
